<script setup lang="ts">
import type { RoutesNamesList } from '@typed-router';
import { loadTermsComponent } from '~/utils/termsLoader';

type Props = {
  routeName?: string;
};

const props = defineProps<Props>();

const currentTerm = ref<Term | null | undefined>(null);
const pageLoading = ref<boolean>(true);

const { currentRouteName } = useRoutes();

const currentComponent = ref<any>(null);

const loadComponent = async (componentName: string) => {
  currentComponent.value = await loadTermsComponent(componentName);
};

const currentTermFullText = computed(() => {
  const raw = currentTerm.value?.description || '';
  const currentAppUrl = appUrlUpper();
  const siteUrlTemplate = '{site_url}';

  let text = raw;

  // Substitui o placeholder da URL do site
  if (currentAppUrl && siteUrlTemplate && text) {
    text = text.replaceAll(siteUrlTemplate, currentAppUrl);
  }

  if (!text) return text;

  // Normalização de espaçamento:
  // - Remove parágrafos "vazios" que contenham apenas espaços, &nbsp; e/ou <br>
  // - Colapsa múltiplos <br> em apenas um
  // - Remove sequências repetidas de parágrafos totalmente vazios
  text = text
    .replace(/<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '')
    .replace(/(?:\s*<br\s*\/?>\s*){2,}/gi, '<br />')
    .replace(/(?:<p>\s*<\/p>\s*){2,}/gi, '');

  return text;
});

const currentTermName = computed(
  () => props.routeName || currentRouteName.value,
);

onMounted(async () => {
  try {
    currentTerm.value = await useTermsStore().getLegalTerm(
      currentTermName.value as RoutesNamesList,
      'pt-br',
    );

    // Load the appropriate component dynamically
    if (!currentTerm.value?.description) {
      await loadComponent(currentTermName.value);
    }
  } catch (e) {
    console.error('Erro ao encontrar página: ' + e);
    useRouter().push('/');
  } finally {
    pageLoading.value = false;
  }
});
</script>

<template>
  <BaseCommonPages
    v-if="pageLoading || currentTermFullText"
    :date="currentTerm?.updated_at ?? ''"
    :file="currentTerm?.term_file ?? ''"
    :is-loading="pageLoading"
    show-actions
    :title="currentTerm?.title ?? ''"
  >
    <div
      v-if="pageLoading"
      class="skeleton-loading mt-1.5 h-5 w-56"
    />

    <article
      v-else
      v-html="currentTermFullText ?? ''"
    />

    <template v-if="currentTermName === 'betting-terms'">
      <hr class="opacity-5 my-5" />

      <div class="pb-3">
        <h5>{{ $t('terms.agree_regulations') }}</h5>
      </div>
    </template>
  </BaseCommonPages>

  <component
    :is="currentComponent"
    v-else
    :route-name="currentTermName"
  />
</template>
